<div class="snack-container fx-row">
    <span>{{ data.msg }}</span>

    <div class="icon-container">
        <mat-icon>{{ data.icon }}</mat-icon>
    </div>
</div>
